import { render, staticRenderFns } from "./scoreSettings.vue?vue&type=template&id=31477d24&"
import script from "./scoreSettings.vue?vue&type=script&lang=js&"
export * from "./scoreSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports